import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/*
  Generated class for the Certificado page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-modal-certificado',
  templateUrl: 'modal-certificado.html'
})
export class ModalCertificadoPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad CertificadoPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-certificado/modal-certificado.ts